<template>
  <div>
    <v-data-table
      :headers="removeWorkItemDataTableHeaders"
      :items="editedEngineerWork.EngineerWorkItems"
      class="elevation-1 my-5 mx-5"
      :search="searchWorkItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :item-class="isOutOfWarrantyClass"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('engineer_item_repair_item_remove_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchWorkItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowEditWorkItemDialog = true"
            :disabled="
              isAllTextFieldDisable ||
                !editedEngineerWork.IsAccept ||
                editedEngineerWork.IsDone ||
                editedEngineerWork.IsOutOfTime
            "
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditWorkItemDialog" persistent fullscreen>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <!-- 拆機-拆品項 -->
              <ValidationObserver ref="workItem">
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.RemoveItem.IsCustomerDevice"
                            :label="$t('quotation_item_is_customer_device')"
                            required
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.RemoveItem.IsExistResume
                            "
                            @change="setIsCustomerDevice"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.RemoveItem.CustomerDeviceType"
                            :items="computedCustomerDeviceTypeList"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('engineer_item_customer_device_type')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-if="editedWorkItem.RemoveItem.IsCustomerDevice"
                            :disabled="editedWorkItem.IsDone"
                            @keyup.enter="setRemoveItemCustomerDeviceTypeAutocomplete"
                            ref="removeItemDeviceTypeAutocomplete"
                            @change="setCustomerDeviceType"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <item-autocomplete-for-eg
                            :fatherEditedItem="editedWorkItem.RemoveItem"
                            :licensePlate="editedEngineerWork.LicensePlate"
                            :editedItemIndex="editedWorkItemIndex"
                            :itemName="'quotation_item_number'"
                            :customerDeviceType="editedWorkItem.RemoveItem.CustomerDeviceType"
                            @setEditedItem="setEditedRemoveItem"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            v-if="editedWorkItemIndex === -1"
                            refName="removeItemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                            v-else
                          >
                            <v-text-field
                              v-model="editedWorkItem.RemoveItem.Name"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_real_quantity')"
                            :rules="{ required: true, is: isCheckRemoveItemQuantity }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedWorkItem.RemoveItem.RealQuantity"
                              required
                              clearable
                              :disabled="editedWorkItem.IsDone"
                              :error-messages="errors[0]"
                              @keyup.enter="focusNextInput"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_real_quantity') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          xl="4"
                          lg="4"
                          v-if="
                            editedWorkItem.RemoveItem.HasSerialNumber &&
                              editedWorkItem.RemoveItem.OriginalSerialNumber !== ''
                          "
                        >
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.OriginalSerialNumber"
                            :label="$t('engineer_item_original_serial_numbers')"
                            disabled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          editedWorkItem.RemoveItem.HasSerialNumber &&
                            editedWorkItem.RemoveItem.RealQuantity > 0 &&
                            (!editedWorkItem.RemoveItem.IsCustomerDevice ||
                              (editedWorkItem.RemoveItem.IsCustomerDevice &&
                                editedWorkItem.RemoveItem.CustomerDeviceType === 3))
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('quotation_item_serialnumber')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              !editedWorkItem.IsDone && editedWorkItem.RemoveItem.HasSerialNumber
                            "
                          >
                            <v-combobox
                              v-model="editedWorkItem.RemoveItem.SerialNumber"
                              :items="removeItemSerialNumberList"
                              item-text="Number"
                              item-value="Number"
                              required
                              return-object
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @change="setRemoveSerialNumber"
                              @keyup.enter="setRemoveItemSerialNumberAutocomplete"
                              ref="removeItemSerialNumberAutocomplete"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_serialnumber') }}
                              </template>
                            </v-combobox>
                          </ValidationProvider>
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.SerialNumber.Number"
                            :label="$t('quotation_item_serialnumber')"
                            disabled
                            v-else
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.RemoveItem.InstallPosition"
                            :items="allInstallPositionType"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('quotation_item_install_position')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.RemoveItem.IsExistResume
                            "
                            @keyup.enter="setRemoveItemInstallPositionAutocomplete"
                            ref="removeItemInstallPositionAutocomplete"
                            @change="setRealQuantity"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('resume_item_custody')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="editedWorkItem.RemoveItem.Custody"
                              :items="allCustodyType"
                              item-text="Name"
                              item-value="Type"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @keyup.enter="setCustodyAutocomplete"
                              ref="custodyTypeAutocomplete"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('resume_item_custody') }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.RemoveItem.IsPersonalFactor"
                            label="人為"
                            :disabled="editedWorkItem.IsDone"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.RemoveItem.HasAuthorize">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            :items="gmTypeList"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-model="editedWorkItem.RemoveItem.GmServerType"
                            label="GM"
                            :disabled="editedWorkItem.IsDone"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.AuthorizeItemSerialNumber"
                            label="授權序號"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-select
                            v-model="defaultText"
                            :disabled="isAllTextFieldDisable"
                            :items="defaultTextList"
                            @change="changeDefaultText"
                            label="預設文字"
                            v-if="
                              editedWorkItem.RemoveItem.Quantity * 1 !==
                                editedWorkItem.RemoveItem.RealQuantity * 1
                            "
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_reason')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.RemoveItem.Quantity * 1 !==
                                editedWorkItem.RemoveItem.RealQuantity * 1
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_reason') }}
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                          <ValidationProvider
                            name="換GM Server原因"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.RemoveItem.HasAuthorize &&
                                tempGmServerType !== editedWorkItem.RemoveItem.GmServerType
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                換GM Server原因
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </ValidationObserver>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditWorkItem">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="addWorkItem"
                  :disabled="editedWorkItem.IsDone"
                >
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="false"
            :isLoadingSaveBtn="false"
            :isShowDeleteDialog="isShowDeleteEngineerWorkDialog"
            :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
            @closeDelete="closeDeleteWorkItem"
            @confirmDelete="confirmDeleteWorkItem"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          @click="isShowEditWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="isShowDeleteWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.RemoveItem.InstallPosition`]="{ item }">
        {{ turnData(item.RemoveItem.InstallPosition) }}
      </template>
      <template v-slot:[`item.RemoveItem.Custody`]="{ item }">
        {{ turnCustodyData(item.RemoveItem.Custody) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { CustodyType } from '@/js/CustodyType'
import {
  HttpSerialNumber,
  HttpFix,
  HttpAuthorizeMapping,
  HttpInstallPosition
} from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ItemAutocompleteForEg from '@/components/ItemAutocompleteForEg.vue'
import { extend } from 'vee-validate'
import { is } from 'vee-validate/dist/rules'
export default {
  components: { DeleteDialog, ItemAutocompleteForEg },
  name: 'EngineerWorkNotDoneRemove',
  props: {
    headerProps: {
      type: Object
    },
    editedEngineerWork: {
      type: Object
    },
    isAllTextFieldDisable: {
      type: Boolean
    },
    allInstallPositionType: {
      type: Array
    },
    customerDeviceTypeList: {
      type: Array
    }
  },
  data: () => ({
    authorizeMappingObj: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    gmTypeList: [],
    tempGmServerType: 0,
    searchWorkItems: '',
    isShowDeleteEngineerWorkDialog: false,
    isShowEditWorkItemDialog: false,
    editedWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        Type: '',
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        Custody: 0
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Type: '',
        Quantity: 0,
        RealQuantity: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        Custody: 0
      },
      Reason: ''
    },
    defaultWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        Custody: 0
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        Custody: 0
      },
      Reason: ''
    },
    defaultRemoveItem: {
      BomName: '',
      BuyOrRentType: 0,
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      Type: '',
      OriginalSerialNumber: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPosition: 0,
      HasSerialNumber: false,
      WorkType: 1,
      IsPersonalFactor: false,
      Custody: 0
    },
    editedWorkItemIndex: -1,
    removeItemSerialNumberList: [],
    allCustodyType: [],
    installPositionList: [],
    defaultText: ''
  }),
  async mounted () {
    extend('is', {
      ...is,
      message: () => '只能填寫0、1'
    })
    await this.getAllCustodyType()
    await this.getGmTypeList()
    await this.getInstallPositionList()
  },
  computed: {
    defaultTextList () {
      return ['無初始化履歷卡', '初始化履歷卡錯誤']
    },
    computedCustomerDeviceTypeList () {
      let array = []
      if (this.editedWorkItem.RemoveItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedWorkItem.RemoveItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    removeWorkItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'RemoveItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'RemoveItem.Name' },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'RemoveItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'RemoveItem.InstallPosition'
        },
        {
          text: this.$t('resume_item_custody'),
          align: 'start',
          value: 'RemoveItem.Custody'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    title () {
      return this.editedWorkItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    isCheckRemoveItemQuantity () {
      return (
        (this.editedWorkItem.RemoveItem.HasSerialNumber ||
          (this.editedWorkItem.RemoveItem.InstallPosition !== 0 &&
            this.editedWorkItem.RemoveItem.InstallPosition !== null)) &&
        this.editedWorkItem.RemoveItem.RealQuantity * 1 !== 0 &&
        this.editedWorkItem.RemoveItem.RealQuantity * 1 !== 1
      )
    }
  },
  methods: {
    changeDefaultText () {
      this.editedWorkItem.Reason = this.defaultText
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
    },
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    async getAuthorizeMappingByItemIdAndItemSerialNumber () {
      if (this.editedWorkItem.RemoveItem.SerialNumber) {
        let response = await HttpAuthorizeMapping.GetAuthorizeMappingByItemIdAndItemSerialNumber({
          itemId: this.editedWorkItem.RemoveItem.ItemId,
          itemSerialNumber: this.editedWorkItem.RemoveItem.SerialNumber.Number
        })
        this.authorizeMappingObj = response && response.status === 200 ? response.data.Data : {}
      }
    },
    setCustomerDeviceType () {
      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
    },
    turnCustodyData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    setCustodyAutocomplete (event) {
      this.$refs.custodyTypeAutocomplete.isMenuActive = false
      this.$refs.custodyTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    setIsCustomerDevice () {
      this.editedWorkItem.RemoveItem.CustomerDeviceType = 3
      this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(
        JSON.stringify(this.defaultRemoveItem.SerialNumber)
      )
    },
    isOutOfWarrantyClass (item) {
      if (item.RemoveItem.IsOutOfWarranty && item.RemoveItem.BuyOrRentType === 1) {
        return 'red'
      }
      if (item.RemoveItem.IsPersonalFactor) {
        return 'yellow'
      }
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    setRealQuantity () {
      if (
        this.editedWorkItem.RemoveItem.InstallPosition !== null &&
        this.editedWorkItem.RemoveItem.InstallPosition !== 0
      ) {
        this.editedWorkItem.RemoveItem.RealQuantity = 1
      } else if (!this.editedWorkItem.RemoveItem.HasSerialNumber) {
        this.editedWorkItem.RemoveItem.InstallPosition = 0
      }
    },
    setRemoveItemCustomerDeviceTypeAutocomplete (event) {
      this.$refs.removeItemDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.removeItemDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemoveItemSerialNumberAutocomplete (event) {
      this.$refs.removeItemSerialNumberAutocomplete.isMenuActive = false
      this.$refs.removeItemSerialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async setRemoveSerialNumber () {
      if (typeof this.editedWorkItem.RemoveItem.SerialNumber === 'string') {
        let serialNumberObj = this.removeItemSerialNumberList.find(
          (x) => x.Number === this.editedWorkItem.RemoveItem.SerialNumber
        )
        if (serialNumberObj) {
          this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(JSON.stringify(serialNumberObj))
        } else {
          this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(
            JSON.stringify({
              ItemId: this.editedWorkItem.RemoveItem.ItemId,
              Number: this.editedWorkItem.RemoveItem.SerialNumber,
              IsUsed: true,
              AcceptanceNumber: '',
              RepairNumber: ''
            })
          )
        }
      }
      await this.getAuthorizeMappingByItemIdAndItemSerialNumber()

      if (this.authorizeMappingObj) {
        this.tempGmServerType = this.authorizeMappingObj.GmServerType
        this.editedWorkItem.RemoveItem.GmServerType = this.authorizeMappingObj.GmServerType
        this.editedWorkItem.RemoveItem.AuthorizeItemSerialNumber = this.authorizeMappingObj.AuthorizeItemSerialNumber
        this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      }
    },
    async setEditedRemoveItem (val) {
      this.editedWorkItem.RemoveItem.BomId = val.BomId
      this.editedWorkItem.RemoveItem.BomName = val.BomName
      this.editedWorkItem.RemoveItem.BomDescribe = val.BomDescribe
      this.editedWorkItem.RemoveItem.BuyOrRentType = val.BuyOrRentType
      this.editedWorkItem.RemoveItem.ItemId = val.Id
      this.editedWorkItem.RemoveItem.Number = val.Number
      this.editedWorkItem.RemoveItem.Name = val.Name
      this.editedWorkItem.RemoveItem.Unit = val.Unit
      this.editedWorkItem.RemoveItem.Price = val.Price
      this.editedWorkItem.RemoveItem.IsDelete = val.IsDelete
      this.editedWorkItem.RemoveItem.StoreNo = val.StoreNo
      this.editedWorkItem.RemoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedWorkItem.RemoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedWorkItem.RemoveItem.IsExistResume = val.IsExistResume
      this.editedWorkItem.RemoveItem.HasAuthorize = val.HasAuthorize
      this.editedWorkItem.RemoveItem.Type = val.Type
      await this.getRemoveItemSerialNumber()
      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
    },

    async getRemoveItemSerialNumber () {
      let param = {
        itemId: this.editedWorkItem.RemoveItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.removeItemSerialNumberList = response.status === 200 ? response.data.Data : []
    },
    async isShowEditWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))

      if (this.editedWorkItem.RemoveItem.HasSerialNumber) {
        await this.getRemoveItemSerialNumber()
      }
      if (
        this.editedWorkItem.RemoveItem.HasSerialNumber &&
        this.editedWorkItem.RemoveItem.OriginalSerialNumber !== '' &&
        !this.editedWorkItem.RemoveItem.SerialNumber
      ) {
        let removeItemSerialNumber = this.removeItemSerialNumberList.find(
          (x) =>
            x.Number === this.editedWorkItem.RemoveItem.OriginalSerialNumber &&
            x.ItemId === this.editedWorkItem.RemoveItem.ItemId
        )
        this.editedWorkItem.RemoveItem.SerialNumber = removeItemSerialNumber || {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        }
      }
      if (this.editedWorkItem.RemoveItem.Custody === 0) {
        if (this.editedWorkItem.RemoveItem.BuyOrRentType === 1) {
          this.editedWorkItem.RemoveItem.Custody = 2
        } else {
          this.editedWorkItem.RemoveItem.Custody = 1
        }
      }

      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))

      await this.getAuthorizeMappingByItemIdAndItemSerialNumber()
      if (this.authorizeMappingObj) {
        if (!this.editedWorkItem.RemoveItem.GmServerType) {
          this.editedWorkItem.RemoveItem.GmServerType = this.authorizeMappingObj.GmServerType
        }
        if (!this.editedWorkItem.RemoveItem.AuthorizeItemSerialNumber) {
          this.editedWorkItem.RemoveItem.AuthorizeItemSerialNumber = this.authorizeMappingObj.AuthorizeItemSerialNumber
        }
        this.tempGmServerType = this.authorizeMappingObj.GmServerType
      }
      this.isShowEditWorkItemDialog = true
    },
    async addWorkItem () {
      const isValid = await this.$refs.workItem.validate()
      if (isValid) {
        if (this.editedWorkItemIndex > -1) {
          this.editedEngineerWork.EngineerWorkItems.splice(
            this.editedWorkItemIndex,
            1,
            this.editedWorkItem
          )
        } else {
          this.editedEngineerWork.EngineerWorkItems.push(this.editedWorkItem)
        }
        this.closeEditWorkItem()
      }
    },
    closeEditWorkItem () {
      this.isShowEditWorkItemDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
        this.defaultText = ''
      })
    },
    isShowDeleteWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))
      this.isShowDeleteEngineerWorkDialog = true
    },
    async confirmDeleteWorkItem () {
      this.editedEngineerWork.EngineerWorkItems.splice(this.editedWorkItemIndex, 1)
      this.closeDeleteWorkItem()
    },
    closeDeleteWorkItem () {
      this.isShowDeleteEngineerWorkDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
      })
    }
  }
}
</script>
